export default __webpack_public_path__ + "locales/sl/FillPDFDialog.json?hash=5b71c137758dd23494a1ba94c91fc449";